/*       */

import { gql } from '@apollo/client';

export default gql`
    query graphicLibrarysQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "graphic", filterBy: $filterBy)
        records: graphics(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            type
            image
        }
    }
`;
